export const pxToRem = (value) => {
    return value ? `${value / 16}rem` : 0;
};
